import {
    makeStyles,
} from "@material-ui/core";

export const appStyles = makeStyles(() => ({
    app: {
        minHeight: '100vh',
        position: 'relative',
    },
}));